import React from 'react';
import { Skeleton } from 'components/ui/skeleton';
import MetricStat from './MetricStat';

export interface SummaryItem {
    label: string;
    value: string;
    valueClassName?: string;
}

interface Props {
    title: string;
    asOf?: string;
    items: SummaryItem[];
    loading?: boolean;
}

/** Customer-level totals row shown at the top of the Unbilled / Receivables tabs. */
const SummaryStrip: React.FC<Props> = ({ title, asOf, items, loading }) => (
    <div className="bg-white border border-gray-200 rounded-lg shadow-md shadow-gray-200/60 px-5 py-4">
        <div className="flex items-baseline justify-between mb-3">
            <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
            {asOf && <span className="text-xs text-gray-600">As on {asOf}</span>}
        </div>

        {loading ? (
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-4">
                {Array.from({ length: 7 }).map((_, i) => (
                    <div key={i} className="space-y-2">
                        <Skeleton className="h-3 w-20" />
                        <Skeleton className="h-5 w-16" />
                    </div>
                ))}
            </div>
        ) : (
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-x-4 gap-y-3">
                {items.map((item) => (
                    <MetricStat
                        key={item.label}
                        label={item.label}
                        value={item.value}
                        valueClassName={item.valueClassName}
                    />
                ))}
            </div>
        )}
    </div>
);

export default SummaryStrip;
